import {OrderDetailsSection_BuyNowPayLaterSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/order_success_page/v1/sections.types';
import {useTranslation} from '@aboutyou/i18n';
import {
  COLORS,
  FONT_SIZES,
  Image,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';

export const BuyNowPayLaterSection = (
  props: OrderDetailsSection_BuyNowPayLaterSection,
) => {
  const {paymentMethod, headline, paymentInfoHints} = props;
  const {t} = useTranslation();

  return (
    <BuyNowPayLaterWrapper data-testid="ospBuyNowPayLaterSection">
      <PaymentMethodHeadline>
        <PaymentMethodLabel weight="mediumHeavy">
          {t('Payment method:')}
        </PaymentMethodLabel>{' '}
        <Text>{paymentMethod}</Text>
      </PaymentMethodHeadline>
      <HintsSection>
        <Text size="px14" weight="mediumHeavy">
          {headline}
        </Text>
        <HintsList>
          {paymentInfoHints.map((hint, index) => (
            <HintItem key={index}>
              <HintIcon
                src={hint.icon.url}
                breakpoints={[]}
                ratio="1:1"
                alt=""
              />
              <Text size="px14">{hint.hint}</Text>
            </HintItem>
          ))}
        </HintsList>
      </HintsSection>
    </BuyNowPayLaterWrapper>
  );
};

const BuyNowPayLaterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem 0;
  border-top: 1px solid ${COLORS.Grey3};
  flex: 1;
  line-height: 1.42;

  ${tabletAndUpLinaria(`
    padding: 1.5rem;
    border: 1px solid ${COLORS.Grey3};
    border-radius: 0.25rem;
  `)}
`;

const PaymentMethodHeadline = styled.div`
  font-size: ${FONT_SIZES.px18};
  line-height: 1.44;

  ${tabletAndUpLinaria(`
    font-size: ${FONT_SIZES.px16};
    line-height: 1.5;
  `)}
`;

const PaymentMethodLabel = styled(Text)`
  font-size: inherit;
`;

const HintsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const HintsList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const HintItem = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
`;

const HintIcon = styled(Image)`
  width: 1.5rem;
  height: 1.5rem;
  flex-shrink: 0;
`;
